import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, LayoutDashboard, Plus, ShieldCheck, Settings as SettingsIcon } from "lucide-react";
import { NAV } from "@/constants/testIds";

export default function NavBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  const homePath = user
    ? user.role === "admin"
      ? "/admin"
      : user.role === "agent"
      ? "/agent"
      : "/dashboard"
    : "/";

  return (
    <header className="sticky top-0 z-40 eb-glass">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to={homePath} data-testid={NAV.brand} className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-md bg-[var(--eb-primary)] flex items-center justify-center text-white font-black">ED</div>
          <span className="font-[800] tracking-tight text-lg">ErrandDay</span>
          <span className="hidden md:inline text-[10px] tracking-[0.25em] uppercase text-[var(--eb-text-dim)] ml-1">
            <ShieldCheck className="inline w-3 h-3 mr-1 -mt-0.5" />Trusted in 9ja
          </span>
        </Link>

        <nav className="flex items-center gap-2">
          {user && (
            <>
              <Link
                to={homePath}
                data-testid={NAV.dashboard}
                className="eb-btn eb-btn-ghost !py-2 !px-3 !text-sm hidden sm:inline-flex"
              >
                <LayoutDashboard className="w-4 h-4" /> Dashboard
              </Link>
              {user.role === "client" && (
                <Link to="/tasks/new" data-testid={NAV.newTask} className="eb-btn eb-btn-primary !py-2 !px-4 !text-sm">
                  <Plus className="w-4 h-4" /> New Task
                </Link>
              )}
              <Link
                to="/settings"
                data-testid="nav-settings"
                className="eb-btn eb-btn-ghost !py-2 !px-3 !text-sm"
                title="Settings"
              >
                <SettingsIcon className="w-4 h-4" />
                <span className="hidden md:inline">Settings</span>
              </Link>
              <button
                onClick={onLogout}
                data-testid={NAV.logout}
                className="eb-btn eb-btn-ghost !py-2 !px-3 !text-sm"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden md:inline">Logout</span>
              </button>
              <div data-testid={NAV.profile} className="ml-1 hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full border border-[var(--eb-border)] text-xs">
                <div className="w-6 h-6 rounded-full bg-[var(--eb-surface-2)] flex items-center justify-center text-[var(--eb-primary)] font-bold">
                  {user.name?.[0]?.toUpperCase() || "U"}
                </div>
                <span className="text-[var(--eb-text-dim)]">{user.name}</span>
              </div>
            </>
          )}
          {!user && (
            <>
              <Link to="/login" className="eb-btn eb-btn-ghost !py-2 !px-4 !text-sm">Sign in</Link>
              <Link to="/register" className="eb-btn eb-btn-primary !py-2 !px-4 !text-sm">Get started</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
